import { useRef, useEffect, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  animation?: 'fade-in-up' | 'fade-in-left' | 'fade-in-right' | 'scale-in' | 'fade-in' | 'zoom-in' | 'zoom-in-up' | 'flip-up';
  delay?: number;
  className?: string;
  style?: React.CSSProperties;
  as?: 'div' | 'section' | 'article';
}

export default function AnimatedSection({ children, animation = 'fade-in-up', delay = 0, className = '', style, as: Tag = 'div' }: Props) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const animClass = `animate-${animation}`;
    let playing = false;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          if (playing) return;
          playing = true;
          el.style.opacity = '1';
          el.classList.remove(animClass);
          void el.offsetWidth;
          el.classList.add(animClass);
        } else {
          playing = false;
          el.classList.remove(animClass);
          el.style.opacity = '0';
        }
      },
      { threshold: 0.1 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [animation]);

  return (
    <Tag
      ref={ref}
      className={className}
      style={{ opacity: 0, animationDelay: `${delay}ms`, animationFillMode: 'both', ...style }}
    >
      {children}
    </Tag>
  );
}
